import { When } from 'react-if';
import styled from 'styled-components6';
import { formatDateRange } from 'rwl-shared/dist/utils/date';
import { Body2, getPageUrl, H5, H6, useAnalyticsClickEvent } from 'rwl-ui';
import { CloseButton } from '../buttons';
import {
    faChevronLeft,
    faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { VerticalDivider } from '../Divider';
import { useJob } from '../../fetchers';
import { useContentDetails } from '../../providers';
import { ClickTargets } from 'rwl-shared/dist/models/analytics';

const MobileHeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    padding-top: var(--rwl-spacing-md);
    padding-left: var(--rwl-spacing-md);
    padding-right: 1px solid var(--rwl-palette-gray-300);
    height: 76px; // fix the height so that the header doesn't jump when some elements are empty
`;

export const MobileDetailsHeader = () => {
    const { job } = useJob();
    const { closeDetails } = useContentDetails();
    const sendClickEvent = useAnalyticsClickEvent();

    return (
        <MobileHeaderContainer>
            <div>
                <When condition={job?.title}>
                    <H6>{job?.title}</H6>
                </When>
                <Body2>
                    {job?.startedAt
                        ? formatDateRange(new Date(job?.startedAt))
                        : ''}
                </Body2>
                <Body2>
                    <When condition={job?.locationInfo?.city}>
                        {job?.locationInfo?.city},{' '}
                    </When>
                    {job?.locationInfo?.state}
                </Body2>
            </div>
            <div>
                <CloseButton
                    onClick={() => {
                        sendClickEvent({
                            url: getPageUrl(),
                            target: ClickTargets.CLOSE,
                        });
                        closeDetails();
                    }}
                />
            </div>
        </MobileHeaderContainer>
    );
};

const DesktopDetailsHeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    height: 43px; // Fix so that the header doesn't jump some elements are empty
`;

const Details = styled.div`
    display: flex;
    flex-direction: column;
`;

const ActionButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    color: var(--rwl-palette-gray-500);
    align-items: center;
    gap: var(--rwl-spacing-md);
`;

const ChangeDetailsButton = styled.div`
    cursor: pointer;
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--rwl-radius-lg);
    &:hover {
        background-color: var(--rwl-background-level1);
    }
`;

export const DesktopHeader = () => {
    const { job } = useJob();
    const { closeDetails, itemCount, onNext, onPrev } = useContentDetails();
    const sendClickEvent = useAnalyticsClickEvent();

    return (
        <DesktopDetailsHeaderContainer>
            <Details>
                <H5>{job?.title}</H5>
                <Body2 style={{ fontSize: '14px' }}>
                    {job?.startedAt
                        ? formatDateRange(new Date(job?.startedAt))
                        : ''}
                    {' · '}
                    {job?.locationInfo?.city}, {job?.locationInfo?.state}
                </Body2>
            </Details>
            <ActionButtonContainer>
                <When condition={itemCount > 1}>
                    <ChangeDetailsButton
                        onClick={() => {
                            sendClickEvent({
                                url: getPageUrl(),
                                target: ClickTargets.PREV,
                            });
                            onPrev();
                        }}
                    >
                        <FontAwesomeIcon size="lg" icon={faChevronLeft} />
                    </ChangeDetailsButton>
                    <ChangeDetailsButton
                        onClick={() => {
                            sendClickEvent({
                                url: getPageUrl(),
                                target: ClickTargets.NEXT,
                            });
                            onNext();
                        }}
                    >
                        <FontAwesomeIcon size="lg" icon={faChevronRight} />
                    </ChangeDetailsButton>
                    <VerticalDivider
                        style={{
                            height: '1.5em',
                        }}
                    />
                </When>
                <CloseButton
                    onClick={() => {
                        sendClickEvent({
                            url: getPageUrl(),
                            target: ClickTargets.CLOSE,
                        });
                        closeDetails();
                    }}
                />
            </ActionButtonContainer>
        </DesktopDetailsHeaderContainer>
    );
};
